import { styled } from 'styled-components';
import ArrowIcon from 'assets/arrow-icon';
import { iconSizing, rotate } from 'styles/mixins';

export const StyledArrowIcon = styled(ArrowIcon)`
  ${rotate(270)};
  ${iconSizing.xs};
`;
